<template>
  <div class="wide-highlight-container">
    <WideHighlight
      v-for="(highlight, index) in highlights"
      :key="index"
      :background-image="highlight.backgroundImage"
      :weak-text="highlight.weakText"
      :title="highlight.title"
      :kicker="highlight.kicker"
      :primary-label="highlight.primaryLabel"
      :secondary-label="highlight.secondaryLabel"
      :primary-route="highlight.primaryRoute"
      :secondary-route="highlight.secondaryRoute"
      :project-url="highlight.projectUrl"
      :class="{'wide-highlight': true, 'no-border': index === highlights.length - 1}"
    />
  </div>
</template>

<script>
import WideHighlight from './WideHighlight.vue';
import highlightedProducts from '@/assets/highlighted_products.json';

export default {
  name: 'WideHighlightContainer',
  components: {
    WideHighlight,
  },
  data() {
    return {
      highlights: highlightedProducts.products.map(product => ({
        title: product.title || 'Toprağa değer, üreticiye güven.',
        kicker: product.kicker || 'OCN Gübre',
        weakText: product.description,
        backgroundImage: product.image_url,
        projectUrl: product.project_url,
        primaryLabel: product.primary_label || 'Kurumsal',
        secondaryLabel: product.secondary_label || 'Ürünler',
        primaryRoute: product.primary_route || '/kurumsal',
        secondaryRoute: product.secondary_route || '/urunler'
      }))
    };
  },
};
</script>

<style scoped>
.wide-highlight-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  gap: 18px;
}

.wide-highlight {
  border-bottom: 1px solid transparent;
}

.no-border {
  border-bottom: none;
}
</style>
